import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-success-handling',
  templateUrl: './success-handling.component.html',
  styleUrls: ['./success-handling.component.scss'],
})
export class SuccessHandlingComponent implements OnChanges {
  @Input() message: any;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter();

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {}

  close() {
    // this.message = null;
    this.closeEvent.emit();
  }
}
